module.exports = "/_next/static/images/7621bbd778799517b38ed7a6cc130f5c-nubank-indoor-pool@md-2x.jpg";